import styled from '@emotion/styled';
import { space, SpaceProps } from 'styled-system';
import { Section } from '../Section';
import { SectionProps } from '../Section/Section';

export type HeroProps = SectionProps & SpaceProps;

export const Hero = styled(Section)(
  {
    display: 'flex',
    flexDirection: 'column',
    padding: '0',
  },
  space
);
